import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { stats } from '../../data/mock';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative pt-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-slate-50 dark:bg-slate-950" />

      {/* BOLD HEADLINE - New Top Section */}
      <div className="relative bg-slate-900 dark:bg-slate-950 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold leading-[1.1] text-white max-w-5xl">
            Make intelligence the spine of your enterprise, not an ERP feature.
          </h1>
        </div>
      </div>

      {/* EXISTING SPINE SECTION - Preserved */}
      <div className="relative bg-slate-50 dark:bg-slate-900/50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
          {/* Connector Text */}
          <p className="text-sm text-slate-500 dark:text-slate-400 mb-12 max-w-2xl">
            TradeEngine.AI acts as the intelligence layer powering the spine of the stack.
          </p>

          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              {/* Headline */}
              <h2 className="text-4xl lg:text-5xl font-bold leading-tight">
                <span className="text-slate-900 dark:text-white">The </span>
                <span className="text-orange-500">Spine</span>
                <span className="text-slate-900 dark:text-white"> of Your Stack</span>
              </h2>

              {/* Subheadline */}
              <p className="text-lg text-slate-600 dark:text-slate-400 leading-relaxed max-w-xl">
                An intelligence layer that unifies trade execution, inventory, risk, financing, 
                accounting, and operational visibility into one secure, auditable core — without replacing your existing systems.
              </p>

              {/* CTA Button - Simplified */}
              <div className="flex flex-wrap gap-4 pt-4">
                <Button
                  onClick={scrollToContact}
                  size="lg"
                  className="bg-slate-900 dark:bg-white dark:text-slate-900 hover:bg-slate-800 dark:hover:bg-slate-100 text-white px-8 py-6 text-base font-medium"
                >
                  Request a Demo
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </div>

              {/* Trust Badges */}
              <div className="flex flex-wrap items-center gap-6 pt-6">
                <div className="flex items-center gap-2 text-slate-500 dark:text-slate-400 text-sm">
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                  Enterprise Ready
                </div>
                <div className="flex items-center gap-2 text-slate-500 dark:text-slate-400 text-sm">
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                  Cloud-Native
                </div>
                <div className="flex items-center gap-2 text-slate-500 dark:text-slate-400 text-sm">
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                  SOC 2 Compliant
                </div>
              </div>
            </div>

            {/* Right Content - Stats Card */}
            <div className="relative">
              <div className="relative bg-white dark:bg-slate-800/80 backdrop-blur-xl rounded-2xl border border-slate-200 dark:border-slate-700 shadow-xl p-8 lg:p-10">
                <div className="space-y-8">
                  <h3 className="text-xl font-semibold text-slate-900 dark:text-white">
                    Go Live in Days, Not Months
                  </h3>
                  
                  <div className="grid grid-cols-2 gap-5">
                    {stats.map((stat, index) => (
                      <div
                        key={index}
                        className="p-4 rounded-xl bg-slate-50 dark:bg-slate-900/50 border border-slate-100 dark:border-slate-700/50"
                      >
                        <div className="text-2xl lg:text-3xl font-bold text-orange-500">
                          {stat.value}
                        </div>
                        <div className="text-sm text-slate-500 dark:text-slate-400 mt-1">
                          {stat.label}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="flex items-center gap-3 p-4 rounded-xl bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800/30">
                    <div className="w-2 h-2 rounded-full bg-emerald-500" />
                    <span className="text-slate-700 dark:text-slate-300 text-sm">Your operations evolve. We adapt with you.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
